import {
  LeadBannerGoal,
  type LeadBannerFormGoalParams,
  type LeadBannerGoalParams,
  type LeadBannerTrackingContext,
  type LeadBannerViewGoalParams,
} from '../model/leadBanner';

type LeadBannerGoalParamsBuilder = (context: LeadBannerTrackingContext, cardId: string) => LeadBannerGoalParams;

export function getLeadBannerViewGoalParams(
  context: LeadBannerTrackingContext,
  cardId: string,
): LeadBannerViewGoalParams {
  return {
    placement: context.placement,
    card_id: cardId,
    position: context.position,
    trigger_reason: context.triggerReason,
  };
}

export function getLeadBannerFormGoalParams(
  context: LeadBannerTrackingContext,
  cardId: string,
): LeadBannerFormGoalParams {
  return {
    placement: context.placement,
    card_id: cardId,
    trigger_reason: context.triggerReason,
  };
}

const LEAD_BANNER_GOAL_PARAMS: Record<LeadBannerGoal, LeadBannerGoalParamsBuilder> = {
  [LeadBannerGoal.Impression]: getLeadBannerViewGoalParams,
  [LeadBannerGoal.SheetOpen]: getLeadBannerViewGoalParams,
  [LeadBannerGoal.FormStart]: getLeadBannerFormGoalParams,
  [LeadBannerGoal.FormSubmit]: getLeadBannerFormGoalParams,
};

export function getLeadBannerGoalParams(
  goal: LeadBannerGoal,
  context: LeadBannerTrackingContext,
  cardId: string,
): LeadBannerGoalParams {
  return LEAD_BANNER_GOAL_PARAMS[goal](context, cardId);
}
